import { Percent } from "@silo/types";
import { cn } from "../../../utils/class-names";
import { asPercent } from "@silo/utils";

interface TotalAprProps {
  className?: string;
  hasCollateralRewards: boolean;
  totalCollateralApr: Percent;
}

export function TotalApr({
  className,
  hasCollateralRewards,
  totalCollateralApr,
}: TotalAprProps): JSX.Element {
  return (
    <div
      className={cn(
        "font-mono text-2xl font-medium",
        hasCollateralRewards ? "text-amber-300" : "text-white",
        className
      )}
    >
      {hasCollateralRewards && "+"}
      {asPercent(totalCollateralApr)}
    </div>
  );
}
